import { atom } from 'jotai'
import {eventType} from "@/lib/definitions/definitions";

export const eventsState = atom<eventType[]>([]);
